import Intercom from "@intercom/messenger-js-sdk";
import { useEffect } from "react";
import { User } from "../api/user";

export const useIntercom = (user?: User) => {
  useEffect(() => {
    if (user) {
      Intercom({
        app_id: "ctpql9ea",
        page_title: "Mentors",
        alignment: "left",
        horizontal_padding: 100,
        hide_default_launcher: true,
        user_id: user.id,
        name: user.first_name || "Mentor",
        email: user.email ?? undefined,
        created_at: new Date(user.created_at).getTime() / 1000,
      });
    } else {
      Intercom({
        app_id: "ctpql9ea",
        page_title: "Login - Mentor Dashboard Access Request",
        alignment: "left",
        horizontal_padding: 100,
        hide_default_launcher: true,
        custom_attributes: {
          access_request: true,
          page_context: "login_page",
          security_note: "User attempting to access mentor dashboard - identity verification required",
        },
      });
    }
  }, [user]);

  const openMessenger = () => {
    if (window.Intercom) {
      window.Intercom("show");
    }
  };

  return { openMessenger };
};
